<template>
  <div style="text-align: left; font-size: 0.24rem">
    <ul class="enable-list-type">
      <li style="color: #ff5455; font-weight: bold">完成微信支付后，请务必在显示二维码的页面点击【我已付款完成】。未点击将无法到账。</li>
      <li>本支付通道仅支持微信支付。</li>
      <li>入金时必须由本人操作。</li>
      <li>请勿添加备注信息。</li>
    </ul>
  </div>
</template>
<script>
export default {
  name: 'WechatPayAlert'
}
</script>
